import React from "react"
import styled from "styled-components"
import { ContentActionDispatcher } from "../../../../actiondispacher/content-action-dispacher"
import { IEditorContent } from "../../../../types"
import { IMenuOptions, Menu } from "./components/menu"

interface IProps {
  content: IEditorContent
  contents: IEditorContent[]
  actions: ContentActionDispatcher
  options: IMenuOptions
}

export const AddButton = (props: IProps) => {
  return (
    <MenuWrapper>
      <Menu {...props} />
    </MenuWrapper>
  )
}

const MenuWrapper = styled.div`
  text-align: center;
`
